import Vue from 'vue'
import AVisibility from 'shared/AVisibility'
import ALink from 'shared/ALink'
import ATextInput from 'shared/ATextInput'
import ACheckbox from 'shared/ACheckbox'
import AImage from 'shared/AImage'
import AIframe from 'shared/AIframe'
import AScript from 'shared/AScript'
import LazyHydrate from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

Vue.component('a-visibility', AVisibility)
Vue.component('a-link', ALink)
Vue.component('a-text-input', ATextInput)
Vue.component('a-checkbox', ACheckbox)
Vue.component('a-image', AImage)
Vue.component('a-iframe', AIframe)
Vue.component('a-script', AScript)
Vue.component('a-lazy-hydrate', LazyHydrate)
